import { TimelineScale } from './types';

export const hour = 1000 * 60 * 60;
export const timelineLabelWidth = 120;

// How many units to show on the timeline ruler for the screen
export const defaultTimelineUnitCount: Record<TimelineScale, number> = {
  hours: 12, // 12 hours on the ruler at a time
  days: 7, // 1 week on the ruler at a time
  weeks: 4, // 4 weeks on the ruler at a time
};

// How many subdivisions within each unit to show on the timeline ruler
export const scaleSubdivisionDefaults: Record<TimelineScale, number> = {
  hours: 4, // 15 minutes increments
  days: 8, // 3 hour increments
  weeks: 7, // 1 day increments
};
